import { OnInit } from '@angular/core';
var ContextComponent = /** @class */ (function () {
    function ContextComponent() {
    }
    ContextComponent.prototype.ngOnInit = function () {
    };
    return ContextComponent;
}());
export { ContextComponent };
